import { AttentionBanner } from '@flos/react-ui';
import { useResourceBundle } from '../contexts/ResourceContext';
import { isLocalTimeZoneSameAsCopenhagenTimeZone } from '../services/timezone';
import { trackTimeZoneDifference } from '../services/tracking';
import FormGroup from './common/FormGroup';
const TimeZoneAlert = () => {
  const resource = useResourceBundle();

  const showAlert = !isLocalTimeZoneSameAsCopenhagenTimeZone();

  if (showAlert) {
    trackTimeZoneDifference();
  }

  return showAlert ? (
    <FormGroup>
      <AttentionBanner iconShape="clock-around" className="u-spacing-stack-l">
        {resource['label.schedule.timezone.different']}
      </AttentionBanner>
    </FormGroup>
  ) : null;
};

export default TimeZoneAlert;
